import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import Ticket from 'models/ticket/ticket.model';
import { TicketService } from 'services/ticket/ticket.service';

@Component({
  selector: 'app-upload-ticket-file',
  templateUrl: './upload-ticket-file.component.html',
  styleUrls: ['./upload-ticket-file.component.scss'],
})
export class UploadTicketFileComponent {
  @Input() fileType: string = 'image';
  @Input() ticket: Ticket = new Ticket();
  @Input() refresh: BehaviorSubject<boolean> = new BehaviorSubject(true);

  fileToUpload: File = null;

  constructor(public ticketService: TicketService) { }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  async uploadFile() {
    if (this.fileType === "image") {
      await this.ticketService.uploadImage(this.ticket, this.fileToUpload);
    } else if (this.fileType === "audio") {
      await this.ticketService.uploadSound(this.ticket, this.fileToUpload);
    }
    this.refresh.next(true);
    this.fileToUpload = null;
  }
}
